<template>
  <div class="ml-3 mb-3">
    <!--#E2E2E2-->
    <div
      v-if="!showOptionsUpload && listDocuments.length == 0 && isReadOnlyMode"
      class="container-document"
    >
      <div class="d-flex justify-content-center p-md-4">
        <action-button
          id="actionBtnDownSavedDocumentSigned"
          class="border-btn font-weight-bold"
          i="fas fa-file-medical fa-lg pr-3 pt-2 pb-2 font-17 text-green"
          text="Presione aquí para anejar documento"
          variant="outline pl-5 pt-1 pb-1  pr-5 pl-2"
          @click="showUploadOptions()"
        />
      </div>
    </div>
    <br />

    <custom-modal
      cancel-text="Cancelar"
      icon="fas fa-exclamation-circle"
      is-centered
      save-text="Aceptar"
      show-cancel
      show-save
      title="Certificación"
      :value="showModal"
      width="750px"
      @cancel="onCancelAcceptTermHandler"
      @save="onAcceptTermHandler"
    >
      <custom-checkbox-single-option
        id="customCheckboxShowCertification"
        v-model="acceptedTerms"
        class="font-16"
        option-text="Acepto los términos y responsabilidades"
        title="Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)"
      />
    </custom-modal>

    <custom-callout
      v-for="(item, idx) in listDocuments"
      :key="idx"
      border-color-hex="#E2E2E2"
      class="ml-2 mt-3"
      :has-toggle="false"
    >
      <div class="row p-md-2">
        <div class="col-md-4 col-sm-12">
          <span class="data-title d-block border-mobile">
            Tipo de Documento:
          </span>
          <span class="font-16 color-black">{{ item.documentTypeName }}</span>
        </div>
        <div class="col-md-4 col-sm-12">
          <span class="data-title d-block border-mobile">Archivo:</span>
          <span class="font-16 color-black">{{ item.filename }}</span>
        </div>
        <div
          class="
            col-md-4 col-sm-12
            d-flex
            justify-content-end
            align-items-center
          "
        >
          <div class="mr-md-5">
            <action-button
              id="actionBtnDownloadDocumentSigned"
              class="border-btn font-weight-bold"
              i="fas fa-file-download fa-lg  pt-2 pb-2 pl-2  font-20 text-green"
              variant="outline-success  mr-2 pl-1 pr-1 pt-1 pb-1"
              @click="onDownloadFile(item)"
            />
            <action-button
              v-if="canDeleteDocument"
              id="actionBtnDeleteDocumentSigned"
              class="border-btn font-weight-bold"
              i="fas fa-times-circle fa-lg pt-2 pb-2 pl-2 pr-0  font-19"
              variant="outline-danger  mr-2 pl-0 pr-0 pt-1 pb-1"
              @click="deleteBillDoc(item)"
            />
          </div>
        </div>
      </div>
    </custom-callout>
    <div v-if="showOptionsUpload" class="container-document ml-2 mt-3">
      <validation-observer ref="billDocumentForm" v-slot="{}" tag="form">
        <div class="row p-md-4">
          <div class="col-md-4 col-sm-12">
            <span class="data-title d-block border-mobile">
              Tipo de Documento:
            </span>
            <span class="font-16 color-black">
              <validation-provider
                v-slot="{ errors }"
                name="documentType"
                rules="required"
              >
                <custom-drop-down
                  id="bill-change-status-dropdown-status"
                  v-model="typeDocument"
                  :clearable="false"
                  custom-error-msg="El tipo de documento es requerido."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="value"
                  :options="typeDocuments"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </span>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="ml-5">
              <span class="data-title d-block border-mobile">Archivo:</span>
              <span class="font-16 color-black">
                <validation-provider
                  v-slot="{ errors }"
                  name="fileUpload"
                  rules="required"
                >
                  <custom-file-input
                    v-if="!fileSelected.name"
                    id="customInptFileUploadDocumentsPdf"
                    ref="documentInputRef"
                    :accept="'pdf'"
                    class="file-input__extended"
                    :custom-error-msg="'El archivo es requerido.'"
                    display-style="normal"
                    :error="errors[0]"
                    :on-download="onDownloadFile"
                    required
                    :value="fileSelected.file"
                    @input="onChangeFile"
                  />
                  <span
                    v-if="fileSelected.name"
                    class="font-16 color-black align-file"
                  >
                    {{ fileSelected.name }}
                  </span>
                </validation-provider>
              </span>
            </div>
          </div>
          <div
            class="
              col-md-4 col-sm-12
              d-flex
              justify-content-end
              align-items-center
            "
          >
            <div class="align-button-group">
              <action-button
                id="actionBtnCancelDocumentSigned"
                i="fas fa-times-circle  pl-2"
                text="Cancelar"
                variant="outline-danger mr-2 mt-4 mb-4 pr-3 pl-2"
                @click="cancelUploadDocument"
              />
              <action-button
                id="actionBtnDownSavedDocumentSigned"
                i="fas fa-save fa-lg pl-2 mt-1 mb-1"
                text="Guardar"
                variant="success mr-5 mt-4 mb-4  pr-3 pl-2"
                @click="saveDoc"
              />
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
    <div
      v-if="
        canUploadDocument &&
          listDocuments != 0 &&
          !showOptionsUpload &&
          isReadOnlyMode
      "
      class="d-flex justify-content-end"
    >
      <action-button
        id="actionBtnDownSavedDocumentSigned"
        i="fas fa-file-plus fa-lg pl-2 mt-1 mb-1"
        text="Añadir"
        variant="success  mt-4 mb-4  pr-3 pl-0"
        @click="add"
      />
    </div>
  </div>
</template>

<script>
import objectToFormData from 'object-to-formdata';
import ActionButton from 'ActionButton';
import CustomCallout from 'custom-callout';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
import CustomFileInput from 'CustomFileInput';
import CustomDropDown from 'custom-drop-down';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import CustomModal from 'CustomModal';
import CustomCheckboxSingleOption from 'custom-checkbox-single-option';
import billingStatus from '@/utils/constants/billingStatus';
import {
  addBillingDocument,
  getBillingDocuments,
  deleteBillDocument,
} from '@/services/provider/billing-document.api';
const BILL_DOC_TYPE = {
  OTROS: 96,
  CERTIFICACION: 90,
  BILL_OTROS: 7,
  BILL_CERTIFICACION: 1,
};
export default {
  name: 'BillDocuments',
  mixins: [alertMixin],
  components: {
    ActionButton,
    CustomCallout,
    CustomCheckboxSingleOption,
    CustomModal,
    CustomFileInput,
    CustomDropDown,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      typeDocument: null,
      showOptionsUpload: false,
      showModal: false,
      acceptedTerms: false,
      listDocuments: [],
      typeDocuments: [
        {
          id: BILL_DOC_TYPE.CERTIFICACION,
          value: 'Certificación del Proveedor',
          billingDocType: BILL_DOC_TYPE.BILL_CERTIFICACION,
        },
        {
          id: BILL_DOC_TYPE.OTROS,
          value: 'Otros',
          billingDocType: BILL_DOC_TYPE.BILL_OTROS,
        },
      ],
      fileSelected: {
        name: null,
        attachment: null,
      },
    };
  },
  async mounted() {
    this.getDocuments();
  },
  computed: {
    canUploadDocument() {
      return this.isReadOnlyMode;
    },
    canDeleteDocument() {
      return this.isReadOnlyMode;
    },
    isReadOnlyMode() {
      return (
        this.data?.statusId == billingStatus.Preliminar ||
        this.data?.statusId == billingStatus.PendienteInformacion
      );
    },
  },
  methods: {
    showUploadOptions() {
      this.showOptionsUpload = !this.showOptionsUpload;
    },
    async getDocuments() {
      let payload = {
        academicYearId: this.data.academicYearId,
        companyId: this.data.companyId,
        monthNumber: this.data.monthNumber,
      };
      await getBillingDocuments(payload)
        .then((data) => {
          this.listDocuments = data.data;
          let exist = this.listDocuments.find(
            (data) => data.documentTypeId === BILL_DOC_TYPE.CERTIFICACION
          );
          if (exist) {
            this.typeDocuments = [
              {
                id: BILL_DOC_TYPE.OTROS,
                value: 'Otros',
                billingDocType: 7,
              },
            ];
          } else {
            this.typeDocuments = [
              {
                id: BILL_DOC_TYPE.CERTIFICACION,
                value: 'Certificación del Proveedor',
                billingDocType: BILL_DOC_TYPE.BILL_CERTIFICACION,
              },
              {
                id: BILL_DOC_TYPE.OTROS,
                value: 'Otros',
                billingDocType: BILL_DOC_TYPE.BILL_OTROS,
              },
            ];
          }
        })
        .catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        });
    },
    onDownloadFile(item) {
      _downloadDocumentByAttachmentId(item.documentAttachmentId).catch(
        (err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        }
      );
    },
    cancelUploadDocument() {
      this.typeDocument = null;
      this.fileSelected.name = null;
      this.fileSelected.file = null;
      this.showUploadOptions();
    },
    add() {
      this.showUploadOptions();
    },
    async deleteBillDoc(item) {
      await deleteBillDocument(item.documentId)
        .then(async () => {
          await this.getDocuments();
        })
        .catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        });
    },
    async saveDoc() {
      const isValid = await this.$refs.billDocumentForm.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      } else {
        this.showModal = true;
      }
    },
    async onChangeFile(file) {
      if (file) {
        this.fileSelected.name = file.name;
        this.fileSelected.file = file;
      }
    },
    onCancelAcceptTermHandler() {
      this.showModal = false;
      this.acceptedTerms = false;
    },
    async onAcceptTermHandler() {
      if (!this.acceptedTerms) {
        this.ShowToast(
          'Alerta',
          'Favor certifique el documento  que ha subido al sistema REMpro.',
          'error'
        );
        return;
      }

      this.acceptedTerms = false;
      this.showModal = false;
      let payload = {
        documentId: null,
        documentAttachmentId: '00000000-0000-0000-0000-000000000000',
        filename: this.fileSelected.name,
        documentTypeId: this.typeDocument.id,
        documentTypeName: this.typeDocument.value,
        billingDocumentTypeId: this.typeDocument.billingDocType,
        BillingDocumentTypeName: this.typeDocument.value,
        academicYearId: this.data.academicYearId,
        companyId: this.data.companyId,
        monthNumber: this.data.monthNumber,
        file: this.fileSelected.file,
      };
      let dataToSend = objectToFormData(payload, {
        indices: true,
        nullsAsUndefineds: true,
      });

      await addBillingDocument(dataToSend)
        .then(() => {
          this.getDocuments();
          this.typeDocument = null;
          this.fileSelected.name = null;
          this.fileSelected.file = null;
          this.showOptionsUpload = false;
          this.ShowToast(
            'Alerta',
            'El documento se ha guardado exitosamente.',
            'success'
          );
        })
        .catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container-info {
  position: relative;
  top: -15px;
}
.orange-icon {
  color: #ff7058;
}
.container-document {
  background-color: #f7f7f7;
  border-radius: 5px;
}
.center-file-input {
  width: 450px;
  margin-left: auto;
  margin-right: auto;
}
.align-button-group {
  margin-top: 5px;
}
.border-btn {
  border-color: #c4cdcf;
}
</style>
